import React, { memo, useEffect, useState } from 'react'
import Collapse from 'antd/lib/collapse'
import styles from './node.module.less'
import { TemplateMenu } from './TemplateMenu'
import { LeftMenu } from './LeftMenu'


interface PanelOptions {
  isTemplate?: boolean
}

export const LeftPanel = memo((props: PanelOptions) => {
  const {isTemplate = false} = props

  return (
    <div className={styles.container}>
      {isTemplate && <TemplateMenu />}
      {!isTemplate && <LeftMenu />}
    </div>
  )
})
